var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"touch",rawName:"v-touch",value:({right: function () { return _vm.swipe(); }}),expression:"{right: () => swipe()}"}]},[_c('Videos')],1)}
var staticRenderFns = []

export { render, staticRenderFns }